import { USER_PREFERENCES_ACTION } from '../../../tools/constants';

const initialState = {
  languages: [],
  currencies: [],
  selectedCountryOption: '',
  selectedLanguage: '',
  selectedCurrency: '',
  isCountryChanged: false,
  isLanguageChanged: false,
  isCurrencyChanged: false,
  isUpdated: false,
  hasFetched: false,
};

const userPreferenceReducer = (state, action) => {
  switch (action.type) {
    case USER_PREFERENCES_ACTION.INITIALIZE:
      return {
        ...state,
        languages: action.payload.languages,
        currencies: action.payload.currencies,
        selectedLanguage: action.payload.selectedLanguage,
        selectedCurrency: action.payload.selectedCurrency,
        hasFetched: true,
      };
    case USER_PREFERENCES_ACTION.COUNTRY_CHANGE:
      return {
        ...state,
        selectedCountryOption: action.payload,
        isCountryChanged: true,
      };
    case USER_PREFERENCES_ACTION.LANGUAGE_CHANGE:
      return {
        ...state,
        selectedLanguage: action.payload,
        isLanguageChanged: true,
      };
    case USER_PREFERENCES_ACTION.CURRENCY_CHANGE:
      return {
        ...state,
        selectedCurrency: action.payload,
        isCurrencyChanged: true,
      };
    default:
      return state;
  }
};

export { initialState, userPreferenceReducer };
